import styled from 'styled-components';

import ConfigurableModal from '~organisms/ConfigurableModal';

export const Container = styled(ConfigurableModal)(({ theme }) => ({
  '& .ant-modal-footer': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: '10rem',
  },

  '& .modal-content': {
    maxWidth: '450rem',
    fontSize: theme.typography.size16,
    letterSpacing: 0,
    fontFamily: theme.typography.family.arial,
    lineHeight: '20rem',
    marginTop: '10rem',
  },
}));
